<p-autoComplete #autoCompElem type="search" (keyup.enter)="selectedSearchEntered($event, stext, autoCompElem)" (onSelect)="selectedSearch($event)" size="100%"
    [delay]="600" [minLength]="2" styleClass="auto-comp-adj" inputStyleClass="form-control" placeholder="&#xF002; search serviceman"
    [(ngModel)]="stext" [suggestions]="searchSuggestData" dropdownMode="current" field="name" (completeMethod)="searchSuggest($event.query)">
    <ng-template let-searchData pTemplate="item">
        <div class="ui-helper-clearfix">
            <div *ngIf="searchData.code !== 'a404'" class="em-redcolor" [innerHTML]="searchData.name"></div>
            <div *ngIf="searchData.code === 'a404'" class="searchcomp" [innerHTML]="searchData.name"></div>
        </div>
    </ng-template>
</p-autoComplete>